module.exports = __webpack_public_path__ + "media/applicants/checkbox-unchecked-8a74015e.png";